import React from 'react'
import { Wrapper } from './styles'
import MenuStatsPanel from '../MenuStatsPanel'
import NavStatsPanel from '../NavStatsPanel'
import OnboardingPackageMiniPanel from '../OnboardingPackagePanel/MiniPanel'
import WhatsNewPanel from '../WhatsNewPanel'

type Props = {
  showsBanner: boolean
  isOnboardingPackageDismissed: boolean
  onOnboardingPackageRestore: () => void
}

export default function LeftSidebar({ showsBanner, isOnboardingPackageDismissed, onOnboardingPackageRestore }: Props) {
  return (
    <Wrapper style={{ top: showsBanner ? '118px' : '82px' }}>
      <MenuStatsPanel />
      <NavStatsPanel />
      <OnboardingPackageMiniPanel isVisible={isOnboardingPackageDismissed} onClick={onOnboardingPackageRestore} />
      <WhatsNewPanel />
    </Wrapper>
  )
}
